"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const getAlignment = (rounded, textAlignToFlex) => {
  if (textAlignToFlex) {
    switch (textAlignToFlex) {
      case 'left':
        return 'flex-star';
      case 'center':
        return 'center';
      default:
        return 'flex-start';
    }
  }
  return rounded ? 'center' : ' flex-start';
};
const verticalAlignToFlex = verticalAlign => {
  switch (verticalAlign) {
    case 'top':
      return 'flex-start';
    case 'middle':
      return 'center';
    case 'bottom':
      return 'flex-end';
    default:
      return 'top';
  }
};
const CalloutContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Callout__CalloutContainer",
  componentId: "components-web__sc-1a7ptx-0"
})(_ref => {
  let {
    rounded,
    verticalAlign,
    textAlignToFlex,
    background,
    gap,
    borderRadius,
    padding
  } = _ref;
  return {
    background,
    display: 'flex',
    gap,
    borderRadius,
    padding,
    justifyContent: getAlignment(rounded, textAlignToFlex),
    alignItems: verticalAlignToFlex(verticalAlign)
  };
});
const Callout = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    icon,
    children,
    verticalAlign,
    textAlignToFlex,
    tokens,
    variant = {},
    ...rest
  } = _ref2;
  const {
    background,
    gap,
    borderRadius,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    color
  } = (0, _componentsBase.useThemeTokens)('Callout', tokens, variant);
  const {
    rounded = false,
    size = 'medium'
  } = variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(CalloutContainer, {
    size: size,
    rounded: rounded,
    "data-testid": "callout-container",
    verticalAlign: verticalAlign,
    textAlignToFlex: textAlignToFlex,
    background: background,
    gap: gap,
    borderRadius: borderRadius,
    padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
    ref: ref,
    ...selectProps(rest),
    children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
      tokens: {
        color
      },
      icon: icon,
      variant: {
        rank: 'primary',
        size
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        size,
        compact: size === 'small'
      },
      tokens: {
        color
      },
      children: children
    })]
  });
});
Callout.displayName = 'Callout';
Callout.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('Callout'),
  /**
   * Icon to display on the left side of the Callout
   */
  icon: _propTypes.default.elementType,
  /**
   * Children nodes that can be added
   */
  children: _propTypes.default.node.isRequired,
  /**
   * To change the horizontal alignment of the Callout's text
   */
  textAlignToFlex: _propTypes.default.oneOf(['center', 'left']),
  /**
   * To change the vertical alignment of the Callout's icon
   */
  verticalAlign: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
};
var _default = exports.default = Callout;